import { useMemo, FC, memo } from 'react';
import styled from 'styled-components';

import { useAgoraEngine } from '@providers/AgoraEngineProvider';
import { useParticipantDataById } from '@redux/selectors/participants';
// import { useCurrentUser, useUserDataById } from '@redux/selectors/users';
import {
  ParticipantPosition,
  ParticipantRole,
  ParticipantStatus,
  TeamType,
} from '@typings/participant';

import SkewedBackgroundAvatar from './SkewedBackgroundAvatar';
import NameContainer from './NameContainer';
import MuteButton from './MuteButton';

const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: flex-start;
  justify-content: center;
  overflow: hidden;
  pointer-events: auto;
`;

const MuteButtonWrapper = styled.div`
  position: absolute;
  top: 8px;
  left: 16px;
  z-index: 2;
`;

type Props = {
  participantId: string | null;
  side?: TeamType;
  size: {
    height: number;
    width: number;
  };
  emojisSequence?: string[];
  isSpeaking?: boolean;
  isRecord?: boolean;
  isStatusesShown?: boolean;
  isLikeDisabled?: boolean;
  isLiked?: boolean;
  likesCount?: number;
  onLike?: (isLiked: boolean) => void;
  onEmojiFinish?: () => void;
};

const LeftSideParticipant: FC<Props> = ({
  participantId,
  side,
  size,
  isSpeaking,
  isRecord,
  isStatusesShown,
  isLikeDisabled,
  isLiked,
  likesCount,
  onLike,
}) => {
  // const [currentParticipantId, setCurrentParticipantId] = useState<
  //   string | null
  // >(null);
  const { height, width } = size;
  const participant = useParticipantDataById(participantId);
  // const profileData = useUserDataById(participant?.profileId);
  const { isHost } = useAgoraEngine();
  const isMuted = useMemo(
    () =>
      participant?.status &&
      (participant?.status === ParticipantStatus.ForceMuted ||
        participant?.status === ParticipantStatus.Muted),
    [participant?.status],
  );
  // const currentUser = useCurrentUser();
  // const isMe = useMemo(
  //   () => participant?.profileId === currentUser?.id,
  //   [participant?.profileId, currentUser?.id],
  // );

  if (!participantId) {
    return null;
  }

  return (
    <Container>
      <SkewedBackgroundAvatar
        position={ParticipantPosition.Left}
        userId={participant?.profileId}
        height={height}
        width={width}
        participantRole={
          participant?.role === ParticipantRole.Host ||
          participant?.role === ParticipantRole.CoHost
            ? participant?.role
            : undefined
        }
        isScaling={!isRecord && isSpeaking && !isMuted}
      />

      {isHost && participant?.role === ParticipantRole.Speaker && !isRecord && (
        <MuteButtonWrapper>
          <MuteButton
            participantId={participant.id}
            participantStatus={participant.status}
          />
        </MuteButtonWrapper>
      )}

      <NameContainer
        side={side}
        position={ParticipantPosition.Left}
        participantId={participantId}
        likesCount={likesCount}
        isLiked={isLiked}
        isLikeDisabled={isLikeDisabled}
        onLike={onLike}
        isStatusesShown={isStatusesShown}
        width={width}
      />
    </Container>
  );
};

export default memo(LeftSideParticipant);
